import { StyleSheet, Platform } from 'react-native';

export const adminStyles = StyleSheet.create({
  // Common styles
  container: {
    flex: 1,
    backgroundColor: '#f3f4f6',
    ...(Platform.OS === 'web' ? {
      minHeight: '100vh',
      overflow: 'hidden',
    } : {}),
  },

  // Sidebar styles
  sidebar: {
    width: 240,
    backgroundColor: '#ffffff',
    ...(Platform.OS === 'web' ? {
      height: '100vh',
      position: 'fixed',
      top: 0,
      left: 0,
      display: 'flex',
      flexDirection: 'column',
      borderRight: '1px solid #E5E7EB',
      zIndex: 50
    } : {
      borderRightWidth: 1,
      borderRightColor: '#E5E7EB',
    }),
  },
  
  // Sidebar header
  sidebarHeader: {
    padding: 12,
    paddingVertical: 14,
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    backgroundColor: '#f8fafc',
  },
  brandContainer: {
    marginBottom: 1,
  },
  brandTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#111827',
    marginBottom: 2,
    ...(Platform.OS === 'web' ? {
      fontFamily: 'Inter',
    } : {}),
  },
  brandSubtitle: {
    fontSize: 14,
    color: '#6B7280',
    ...(Platform.OS === 'web' ? {
      fontFamily: 'Inter',
    } : {}),
  },

  // Sidebar navigation
  sidebarNav: {
    flex: 1,
    ...(Platform.OS === 'web' ? {
      overflowY: 'auto',
    } : {}),
  },
  sidebarNavContent: {
    padding: 12,
  },

  // Navigation items
  sidebarItem: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 8,
    paddingHorizontal: 10,
    marginVertical: 1,
    borderRadius: 6,
    ...(Platform.OS === 'web' ? {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    } : {}),
  },
  sidebarItemActive: {
    backgroundColor: '#EFF6FF',
    borderLeftWidth: 2,
    borderLeftColor: '#2563EB',
  },
  sidebarItemInner: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  sidebarItemIcon: {
    marginRight: 10,
    width: 18,
    alignItems: 'center',
    ...(Platform.OS === 'web' ? {
      transition: 'all 0.2s ease',
    } : {}),
  },
  sidebarItemText: {
    fontSize: 13,
    color: '#6B7280',
    fontWeight: '500',
    ...(Platform.OS === 'web' ? {
      fontFamily: 'Inter',
      transition: 'color 0.2s ease',
    } : {}),
  },
  sidebarItemTextActive: {
    color: '#2563EB',
    fontWeight: '600',
  },

  // Sub items
  sidebarSubItems: {
    marginLeft: 32,
    marginTop: 2,
    marginBottom: 2,
  },
  sidebarSubItem: {
    padding: 8,
    paddingHorizontal: 10,
    marginVertical: 1,
    borderRadius: 6,
    ...(Platform.OS === 'web' ? {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    } : {}),
  },
  sidebarSubItemActive: {
    backgroundColor: '#EFF6FF',
  },
  sidebarSubItemText: {
    fontSize: 13,
    color: '#6B7280',
    ...(Platform.OS === 'web' ? {
      fontFamily: 'Inter',
      transition: 'color 0.2s ease',
    } : {}),
  },
  sidebarSubItemTextActive: {
    color: '#2563EB',
    fontWeight: '500',
  },

  // Sidebar footer
  sidebarFooter: {
    padding: 16,
    borderTopWidth: 1,
    borderTopColor: '#E5E7EB',
    backgroundColor: '#f8fafc',
  },
  sidebarFooterText: {
    fontSize: 12,
    color: '#9CA3AF',
    textAlign: 'center',
    ...(Platform.OS === 'web' ? {
      fontFamily: 'Inter',
    } : {}),
  },

  // Header styles
  header: {
    backgroundColor: '#ffffff',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 64,
    ...(Platform.OS === 'web' ? {
      position: 'sticky',
      top: 0,
      zIndex: 10,
    } : {}),
  },
  headerTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#111827',
    ...(Platform.OS === 'web' ? {
      fontFamily: 'Inter',
    } : {}),
  },
  headerActions: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
  },

  // Main content area
  mainContent: {
    flex: 1,
    backgroundColor: '#f3f4f6',
    ...(Platform.OS === 'web' ? {
      minHeight: 'calc(100vh - 64px)',
      overflowY: 'auto',
      marginLeft: 240,
      width: 'calc(100% - 240px)'
    } : {}),
  },
  contentWrapper: {
    padding: 24,
    maxWidth: 1280,
    marginHorizontal: 'auto',
    width: '100%',
  },

  // Card styles
  card: {
    backgroundColor: '#ffffff',
    borderRadius: 8,
    padding: 20,
    ...(Platform.OS === 'web' ? {
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    } : {
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.1,
      shadowRadius: 3,
      elevation: 2,
    }),
  },
});
